<template lang="pug">
  payout-hint-panel(v-if="showNotice")
    i18n(tag="div" path="autoconvert_text")
      template(v-slot:src)
        template(v-if="showReversed")
          span.no-wrap {{moneyFormat(amount, sourceCurrency)}} {{sourceCurrency}}
        template(v-else)
          span.no-wrap {{moneyFormat(rate.dstAmount, destCurrency)}} {{destCurrency}}
      template(v-slot:dest)
        template(v-if="showReversed")
          span.no-wrap {{moneyFormat(rate.dstAmount, destCurrency)}} {{destCurrency}}
        template(v-else)
          span.no-wrap {{moneyFormat(amount, sourceCurrency)}} {{sourceCurrency}}
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';
import {MoneyFormatFilter} from '@/models/filters/money';
import {PayoutCryptoCurrencyNoticeModel} from '@/views/layouts/sidemenu/rates';
import PayoutHintPanel from '@/components/forms/payout/PayoutHintPanel.vue';

import debounce from '@/polyfill/Debounce';

@Component({
  name: 'payout-destination-currency-conversion-notice',
  components: {PayoutHintPanel},
})
export default class PayoutDestinationCurrencyConversionNotice extends Vue {
  model: PayoutCryptoCurrencyNoticeModel = new PayoutCryptoCurrencyNoticeModel();

  debouncedLoadRate: any;

  get showReversed() {
    return this.amount < this.rate.dstAmount;
  }

  @Prop({default: null})
  sourceCurrency: string | null

  @Prop({default: 1})
  amount: number

  @Prop({default: null})
  destCurrency: string | null

  get datasKey() {
    return [this.sourceCurrency, this.destCurrency, this.amount].join('#');
  }

  moneyFormat = MoneyFormatFilter;

  lastLoadedRate = null;

  @Watch('datasKey')
  onDataChanged() {
    this.debouncedLoadRate();
  }

  mounted() {
    this.debouncedLoadRate();
  }

  update() {
    if (this.sourceCurrency === this.destCurrency) return;
    this.lastLoadedRate = null;
    const key = this.datasKey;
    return this.model.loadRate(this.sourceCurrency, this.destCurrency, this.amount).then((model) => {
      if (key === this.datasKey) this.lastLoadedRate = model;
    }).catch((err) => {

    });
  }

  created() {
    this.debouncedLoadRate = debounce(this.update, 1000);
  }

  get hasRate(): boolean {
    return !!this.rate;
  }

  get rate() {
    return this.lastLoadedRate
      ? this.lastLoadedRate.originRate : null; // this.model.getRate(this.sourceCurrency as string, this.destCurrency as string);
  }

  get showNotice() {
    return this.hasRate && (this.sourceCurrency !== this.destCurrency);
  }
}
</script>

<style scoped lang="less">
.no-wrap {
  white-space: nowrap;
}
</style>

<i18n>
{
  "en": {
    "autoconvert_text": "The auto-conversion rate will be applied ({src} = {dest})"
  },
  "ru": {
    "autoconvert_text": "Будет применен курс автоконвертации ({src} = {dest})"
  }
}
</i18n>
